module.exports = __webpack_public_path__ + "static/media/South-western_iberian_bronze_icon_200px.01810ed1.png";